/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { selectEditMode } from "../../slices/editMode/editModeSlice";
import { resourceUpdated, selectResourceById } from "../../slices/resourceCollection/resourceCollectionSlice";
import { selectAllResourceChanges } from "../../slices/resourceChangeReport/resourceChangeReportSlice";
import { useEffect, useState } from "react";
import { changeTopNavigationElements } from "../../slices/navigationPanel/navigationPanelSlice";
import { changeTabMenu } from "../../slices/tabPane/tabPaneSlice";
import updateElement from "../../functions/updateElement";
import updateChangeReport from "../../slices/resourceChangeReport/updateChangeReport";
import Spinner from "../../components/Spinner";
import { Button } from "semantic-ui-react";
import { ReorganizeSectionsModal } from "../ReorderCompositionSections";
import { globalLoadingOff, globalLoadingOn } from "../../slices/globalLoading/globalLoadingSlice";
import { selectOlderVersionFhirString, selectViewingOlderVersion } from "../../slices/viewingOlderVersion/viewingOlderVersionSlice";
import { loadTopSections, selectAllTopSections, selectTopSectionsStatus, topSectionAdded } from "../../slices/topSections/topSectionsSlice";
import { simpleDisplayStringFromFHIRCodeableConcept } from "../../datatypeComponents/CodeableConceptEntry";
import { displayStringFromFHIRReference } from "../../datatypeComponents/ReferenceEntry";
import TopSectionSliceDisplay from "./TopSectionSliceDisplay";

const CompositionBasicDisplay = ({ foi }) => {

    const dispatch = useDispatch();
    const editMode = useSelector(state => selectEditMode(state));
    const parentResourceDetail = useSelector(state => selectResourceById(state, foi));
    const resourceChanges = useSelector(state => selectAllResourceChanges(state));
    const resourceJson = parentResourceDetail?.revisedResourceJson;
    const viewingOlderVersion = useSelector(state => selectViewingOlderVersion(state));
    const olderVersionFhirString = useSelector(state => selectOlderVersionFhirString(state));
    const allTopSections = useSelector(selectAllTopSections);
    const topSectionsStatus = useSelector(selectTopSectionsStatus);

    let isEvidenceReportProfile;
    let isResearchStudyDataDictionaryProfile;
    let isEvidenceReportPackageProfile;
    let isGuidelineProfile;
    let isGuidelineRegistryRecordProfile;
    let isRecommendationProfile;
    let isM11ReportProfile;
    if (resourceJson.meta?.profile?.length) {
        for (const profile of resourceJson.meta.profile) {
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/evidence-report") {
                isEvidenceReportProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/research-study-data-dictionary") {
                isEvidenceReportProfile = true;
                isResearchStudyDataDictionaryProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/m11-report") {
                isEvidenceReportProfile = true;
                isM11ReportProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/evidence-report-package") {
                isEvidenceReportProfile = true;
                isEvidenceReportPackageProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/guideline") {
                isEvidenceReportProfile = true;
                isEvidenceReportPackageProfile = true;
                isGuidelineProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/guideline-registry-record") {
                isEvidenceReportProfile = true;
                isEvidenceReportPackageProfile = true;
                isGuidelineProfile = true;
                isGuidelineRegistryRecordProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/recommendation") {
                isEvidenceReportProfile = true;
                isEvidenceReportPackageProfile = true;
                isRecommendationProfile = true;
            }
        }
    }

    const [compositionResourceState, setCompositionResourceState] = useState({});
    const [extensionState, setExtensionState] = useState({});
    //TODO - for future use to create generated Narrative
    //const [generatedNarrativeState, setGeneratedNarrativeState] = useState(""); 
    const [editSectionModal, setEditSectionModal] = useState({ "openModal": false });
    const [sectionNavigationElementIds, setSectionNavigationElementIds] = useState([]);
    const [sectionsReorganizedState, setSectionsReorganizedState] = useState({});
    const [addSectionState, setAddSectionState] = useState({
        "sectionTitle": "", "addSectionClicked": false
    });
    const [initialLoadCompleted, setInitialLoadCompleted] = useState(false);

    useEffect(() => {
        //console.log("CompositionBasicDisplay useEffect due to change in resourceJson")
        if (initialLoadCompleted !== true && (resourceJson?.id ||
            (viewingOlderVersion && olderVersionFhirString))
        ) {
            dispatch(globalLoadingOn());
            if (viewingOlderVersion && olderVersionFhirString) {
                try {
                    const olderVersionJson = JSON.parse(olderVersionFhirString);
                    setCompositionResourceState(olderVersionJson);
                    let topNavigationElements = [];
                    let sectionHeaderNavigationElements = [];

                    if (Array.isArray(olderVersionJson.section)) {
                        for (const section of olderVersionJson.section) {
                            let sectionCode = section?.code?.coding?.[0]?.display || section?.code?.text || section?.code?.coding?.[0]?.code;
                            let sectionFocus = section?.focus?.display || section?.focus?.reference;
                            let sectionHeader = section.title || sectionCode || sectionFocus || "Unidentified Section";
                            topNavigationElements.push(sectionHeader);
                            sectionHeaderNavigationElements.push(sectionHeader);
                        }
                    }
                    dispatch(changeTopNavigationElements(topNavigationElements));
                    const sectionNavigationIds = sectionHeaderNavigationElements.map(((element) => {
                        let id = element.toLowerCase().replace(/\s/g, "-").replace(/\//g, "-");
                        return id;
                    }))
                    setSectionNavigationElementIds(sectionNavigationIds);

                    let startingExtension = olderVersionJson.extension || [];
                    let startingExtensionStateValue = {
                        "otherExtensions": [], "additionalLanguage": [],
                        "guidelineRegistration": []
                    }
                    if (Array.isArray(startingExtension) && startingExtension.length > 0) {
                        for (const extension of startingExtension) {
                            switch (extension.url) {
                                case 'http://hl7.org/fhir/StructureDefinition/additional-language':
                                    startingExtensionStateValue.additionalLanguage.push(extension.valueCode);
                                    break;
                                case 'http://hl7.org/fhir/uv/ebm/StructureDefinition/guideline-registration':
                                    startingExtensionStateValue.guidelineRegistration.push(extension);
                                    break;
                                default:
                                    startingExtensionStateValue.otherExtensions.push(extension)
                            }
                        }
                    }
                    setExtensionState(startingExtensionStateValue);
                    dispatch(globalLoadingOff());
                } catch {
                    alert("Error viewing JSON of older version.");
                }
            } else if (resourceJson?.id) {
                setCompositionResourceState(resourceJson);
                setSectionsReorganizedState({ "reorganized": false, "section": resourceJson.section });

                let topNavigationElements = [];
                let sectionHeaderNavigationElements = [];

                if (Array.isArray(resourceJson.section)) {
                    for (const section of resourceJson.section) {
                        let sectionCode = section?.code?.coding?.[0]?.display || section?.code?.text || section?.code?.coding?.[0]?.code;
                        let sectionFocus = section?.focus?.display || section?.focus?.reference;
                        let sectionHeader = section?.title || sectionCode || sectionFocus || "Unidentified Section";
                        topNavigationElements.push(sectionHeader);
                        sectionHeaderNavigationElements.push(sectionHeader);
                    }
                }
                dispatch(changeTopNavigationElements(topNavigationElements));
                const sectionNavigationIds = sectionHeaderNavigationElements.map(((element) => {
                    let id = element.toLowerCase().replace(/\s/g, "-").replace(/\//g, "-");
                    return id;
                }))
                setSectionNavigationElementIds(sectionNavigationIds);

                let startingExtension = resourceJson.extension || [];
                let startingExtensionStateValue = {
                    "otherExtensions": [], "additionalLanguage": [],
                    "guidelineRegistration": []
                }
                if (Array.isArray(startingExtension) && startingExtension.length > 0) {
                    for (const extension of startingExtension) {
                        switch (extension.url) {
                            case 'http://hl7.org/fhir/StructureDefinition/additional-language':
                                startingExtensionStateValue.additionalLanguage.push(extension.valueCode);
                                break;
                            case 'http://hl7.org/fhir/uv/ebm/StructureDefinition/guideline-registration':
                                startingExtensionStateValue.guidelineRegistration.push(extension);
                                break;
                            default:
                                startingExtensionStateValue.otherExtensions.push(extension)
                        }
                    }
                }
                setExtensionState(startingExtensionStateValue);
                dispatch(globalLoadingOff());
            }
            setInitialLoadCompleted(true);
        }
    }, [resourceJson, initialLoadCompleted]);

    useEffect(() => {
        //console.log("CompositionBasicDisplay useEffect due to change in extensionState")
        let newExtension = [];
        if (extensionState.otherExtensions) {
            newExtension = JSON.parse(JSON.stringify(extensionState.otherExtensions));
        }
        if (extensionState.additionalLanguage && extensionState.additionalLanguage.length > 0) {
            for (const instance of extensionState.additionalLanguage) {
                newExtension.push({
                    "url": "http://hl7.org/fhir/StructureDefinition/additional-language",
                    "valueCode": instance
                });
            }
        }
        if (extensionState.guidelineRegistration && extensionState.guidelineRegistration.length > 0) {
            for (const instance of extensionState.guidelineRegistration) {
                newExtension.push(instance);
            }
        }
        setCompositionResourceState(prevState => { return { ...prevState, "extension": newExtension } });
    }, [extensionState]);

    useEffect(() => {
        if (editMode && resourceJson) {
            let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
            let previousInitialValue = null;
            let previousFinalValue = null;
            previousInitialValue = newResourceDetail.resourceJson.title;
            previousFinalValue = newResourceDetail.revisedResourceJson.title;
            newResourceDetail.revisedResourceJson.title = compositionResourceState.title;
            newResourceDetail.displayTitle = compositionResourceState.title ||
                compositionResourceState.name || newResourceDetail.displayTitle;
            if (compositionResourceState.title !== undefined &&
                previousFinalValue !== compositionResourceState.title) {
                console.log("resourceUpdate for Composition.title");
                dispatch(resourceUpdated(newResourceDetail));
                updateChangeReport(dispatch, resourceChanges, newResourceDetail.id,
                    "string",
                    "title",
                    previousInitialValue,
                    compositionResourceState.title);
            }
        }
    }, [compositionResourceState.title]);

    useEffect(() => {
        //console.log("CompositionBasicDisplay useEffect due to change in compositionResourceState.extension")
        if (editMode && resourceJson) {
            updateElement(compositionResourceState, "extension", "ArrayOfExtension", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [compositionResourceState.extension]);

    useEffect(() => {
        if (topSectionsStatus === "succeeded" && allTopSections?.length > 0) {
            let newCompositionSection = allTopSections.map(entity => { return entity.revisedSection });
            if (newCompositionSection.length > 0) {
                if (editMode && resourceJson) {
                    let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
                    let previousInitialValue = null;
                    let previousFinalValue = null;
                    previousInitialValue = newResourceDetail.resourceJson.section;
                    previousFinalValue = newResourceDetail.revisedResourceJson.section;
                    newResourceDetail.revisedResourceJson.section = newCompositionSection;
                    if (newCompositionSection !== undefined &&
                        JSON.stringify(previousFinalValue) !== JSON.stringify(newCompositionSection) &&
                        !(!previousInitialValue &&
                            Array.isArray(newCompositionSection) &&
                            (newCompositionSection.length === 0 ||
                                (newCompositionSection.length === 1 &&
                                    !newCompositionSection[0])
                            )
                        )) {
                        console.log("resourceUpdate for Composition.section");
                        dispatch(resourceUpdated(newResourceDetail));
                    }
                }
            }
        }
    }, [allTopSections]);

    useEffect(() => {
        if (editMode && resourceJson && sectionsReorganizedState.reorganized &&
            Array.isArray(sectionsReorganizedState.section) && sectionsReorganizedState.section.length > 0) {
            setSectionsReorganizedState(prevState => { return { ...prevState, "reorganized": false } });
            let oldCompositionSection = allTopSections.map(entity => { return entity.revisedSection });
            if (JSON.stringify(oldCompositionSection) !== JSON.stringify(sectionsReorganizedState.section)) {
                let topSectionArray = sectionsReorganizedState.section.map((section, sectionIndex) => {
                    return {
                        id: sectionIndex,
                        displayTitle: section.title ||
                            simpleDisplayStringFromFHIRCodeableConcept(section.code) ||
                            displayStringFromFHIRReference(section.focus) || "Untitled Section",
                        compositionId: foi,
                        productFamily: parentResourceDetail.productFamily,
                        initialSection: section,
                        revisedSection: section
                    };
                });
                let topSectionsBody = { topSections: topSectionArray };
                dispatch(loadTopSections(topSectionsBody));
                console.log("sectionsReorganized so resourceUpdate for Composition.section");
            }
            let previousInitialValue = parentResourceDetail.resourceJson.section || null;
            updateChangeReport(dispatch, resourceChanges, parentResourceDetail.id,
                "ArrayOfSection",
                "section",
                previousInitialValue,
                sectionsReorganizedState.section);
        }
    }, [sectionsReorganizedState]);

    useEffect(() => {
        if (editMode && resourceJson && addSectionState.addSectionClicked &&
            addSectionState.sectionTitle) {
            let sectionLength = allTopSections.length;
            let sectionBody = {
                id: sectionLength,
                displayTitle: addSectionState.sectionTitle,
                compositionId: foi,
                productFamily: parentResourceDetail.productFamily,
                initialSection: { "title": addSectionState.sectionTitle },
                revisedSection: { "title": addSectionState.sectionTitle }
            }
            dispatch(topSectionAdded(sectionBody));
            console.log("addSectionState so resourceUpdate for Composition.section");
            updateChangeReport(dispatch, resourceChanges, parentResourceDetail.id,
                "CompositionSection",
                "section[" + sectionLength + "]",
                null,
                { "title": addSectionState.sectionTitle });
            setAddSectionState({
                "sectionTitle": "", "addSectionClicked": false
            });
        }
    }, [addSectionState]);

    if (!resourceJson) {
        return <Spinner />;
    }

    return <>
        {compositionResourceState.id && <>
            <div style={{ marginTop: "12px" }}>
                {editMode && <div>
                    <Button className="formButton" style={{ margin: "0px" }}
                        content="Reorganize Sections" compact
                        onClick={() => { setEditSectionModal({ "openModal": true }) }} />
                    <br />
                </div>}
                {(editSectionModal.openModal) &&
                    <>
                        <ReorganizeSectionsModal
                            editSectionModal={editSectionModal}
                            setEditSectionModal={setEditSectionModal}
                            sectionsReorganizedState={sectionsReorganizedState}
                            setSectionsReorganizedState={setSectionsReorganizedState}
                        />
                    </>}
                {(compositionResourceState.section?.length > 0) &&
                    compositionResourceState.section.map((section, sectionIndex) => {
                        return <div key={sectionIndex}>
                            <TopSectionSliceDisplay foi={foi}
                                setCompositionResourceState={setCompositionResourceState}
                                sectionIndex={sectionIndex}
                                sectionNavigationElementIds={sectionNavigationElementIds}
                            />
                            <br />
                        </div>
                    })}
                {editMode &&
                    <>
                        <Button style={{ color: "#000000", width: "130px", float: "left" }}
                            className="formButton"
                            content="+ Add Section"
                            onClick={() => {
                                setAddSectionState({
                                    "sectionTitle": "Replace with Proper Section Title",
                                    "addSectionClicked": true
                                });
                            }}
                        />
                    </>}
            </div>
        </>}
    </>
}

export default CompositionBasicDisplay;